// 模块抽屉组件
"use client";

import { c as _c } from "react/compiler-runtime";
import * as React from "react";
import { Drawer, DrawerContent } from "@/components/ui/drawer";
import { MobileHeader } from "@/components/ui/mobile-header";
import { PullToRefreshWrapper } from "@/components/ui/pull-to-refresh";
import { cn } from "@/lib/utils";
interface ModuleDrawerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  children: React.ReactNode;
  className?: string;
  disableDrag?: boolean;
  onRefresh?: () => Promise<void>;
  disableRefresh?: boolean;
  contentClassName?: string;
  rightContent?: React.ReactNode;
}
export function ModuleDrawer(t0) {
  const $ = _c(23);
  const {
    open,
    onOpenChange,
    title,
    children,
    className,
    disableDrag: t1,
    onRefresh,
    disableRefresh: t2,
    contentClassName,
    rightContent
  } = t0;
  const disableDrag = t1 === undefined ? false : t1;
  const disableRefresh = t2 === undefined ? false : t2;
  const contentRef = React.useRef(null);
  const handleContentTouchStart = _temp;
  let t3;
  if ($[0] !== contentClassName) {
    t3 = cn("flex-1 overflow-y-auto p-4 pb-16", contentClassName);
    $[0] = contentClassName;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== children || $[3] !== t3) {
    t4 = <div ref={contentRef} className={t3} onTouchStart={handleContentTouchStart}>{children}</div>;
    $[2] = children;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const contentDom = t4;
  const t5 = !disableDrag;
  let t6;
  if ($[5] !== className) {
    t6 = cn("fixed inset-0 z-50 !h-100dvh !w-screen   max-w-none rounded-none border-none bg-background p-0", className);
    $[5] = className;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== rightContent || $[8] !== title) {
    t7 = <MobileHeader title={title} rightContent={rightContent} />;
    $[7] = rightContent;
    $[8] = title;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== contentDom || $[11] !== disableRefresh || $[12] !== onRefresh) {
    t8 = onRefresh && !disableRefresh ? <PullToRefreshWrapper onRefresh={onRefresh} className="flex-1" disabled={disableRefresh}>{contentDom}</PullToRefreshWrapper> : contentDom;
    $[10] = contentDom;
    $[11] = disableRefresh;
    $[12] = onRefresh;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t6 || $[15] !== t7 || $[16] !== t8) {
    t9 = <DrawerContent id="module-drawer-content" className={t6}>{t7}{t8}</DrawerContent>;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== onOpenChange || $[19] !== open || $[20] !== t5 || $[21] !== t9) {
    t10 = <Drawer open={open} onOpenChange={onOpenChange} direction="right" shouldScaleBackground={false} dismissible={t5}>{t9}</Drawer>;
    $[18] = onOpenChange;
    $[19] = open;
    $[20] = t5;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  return t10;
}
function _temp(event) {
  const target = event.target as HTMLElement;
  const scrollableElement = target.closest("[data-carousel-container], [style*=\"touch-action\"]");
  if (scrollableElement) {
    return;
  }
}
export function fixModuleDrawerViewport() {
  const content = document.getElementById("module-drawer-content");
  if (content) {
    content.style.height = "99.9dvh";
  }
  requestAnimationFrame(() => {
    if (content) {
      content.style.height = "100dvh";
    }
  });
}